<template>
    <div class="action-premium-start">
        <div class="title" v-html="$translate('ACTION_PREMIUM_START_TITLE')" />
        <div class="message-button" v-if="!content.start && showButton">
            <button @click="start" class="btn btn-primary" v-html="$translate('ACTION_PREMIUM_START_BUTTON')" />
        </div>
    </div>
</template>

<script>
import chatService from '@/services/chat'

export default {
    name: 'ActionPremiumStart',
    props: ['message'],
    data: () => ({
        showButton: true,
    }),
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        content() {
            return this.$mustParse(this.message.content) || {}
        },
        user() {
            return this.content.user || {}
        },
        profile() {
            return this.chat.user.profile
        },
    },
    methods: {
        async start() {
            this.$modal
                .basic({
                    body: '버튼을 누른 시점으로부터 14일간 프리미엄 주선이 시작됩니다.',
                    buttons: [
                        {
                            label: 'ACTION_PREMIUM_START_BUTTON',
                            class: 'btn-primary',
                        },
                    ],
                })
                .then(async idx => {
                    try {
                        if (idx === 0) {
                            this.$loading(true)
                            const data = await chatService.startPremium(this.chat.id, this.message.id)
                            this.$loading(false)
                            // 항상 서버에 요청하고 서버에서 처리
                            if (data.res === 'success') {
                                // this.$toast.success(data.msg)
                                this.$modal.basic({
                                    body: data.msg,
                                    buttons: [
                                        {
                                            label: 'CONFIRM',
                                            class: 'btn-primary',
                                        },
                                    ],
                                })
                                this.showButton = false
                            } else {
                                this.$modal.basic({
                                    body: data.msg,
                                    buttons: [
                                        {
                                            label: 'CONFIRM',
                                            class: 'btn-primary',
                                        },
                                    ],
                                })
                            }
                        }
                    } catch (e) {
                        this.$toast.error(e.data)
                    }
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.action-premium-start {
    width: calc(100% - 8px);

    .message-button {
        display: flex;
        margin: 0 14px 14px;
    }
}
</style>
